export default __webpack_public_path__ + "static/media/Desenvolvimento-Mobile-EN.2e7eb2e7.jpg";